import React from 'react'
import { Box, Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'

function SectionHeader({ icon, title, subtitle }) {
  if (isEmpty(title)) {
    return null
  }
  return (
    <>
      <Typography
        variant="h2"
        sx={{ mb: 3, display: 'flex', alignItems: 'center' }}
      >
        {icon}
        <Box sx={{ ml: 2 }}>{title}</Box>
      </Typography>
      {!isEmpty(subtitle) && (
        <Typography variant="h5" sx={{ mb: 3, ml: 2 }}>
          {subtitle}
        </Typography>
      )}
    </>
  )
}

SectionHeader.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

SectionHeader.defaultProps = {
  icon: null,
  title: '',
  subtitle: '',
}

export default SectionHeader
